import { useEffect, useState } from "react";
import { toast } from "sonner";
import Nav from "../components/Nav";
import PromoBanner from "../components/PromoBanner";
import Hero from "../components/Hero";
import About from "../components/About";
import ForYou from "../components/ForYou";
import Chapters from "../components/Chapters";
import Interlude from "../components/Interlude";
import Preview from "../components/Preview";
import SamplePages from "../components/SamplePages";
import Author from "../components/Author";
import Manifesto from "../components/Manifesto";
import Testimonials from "../components/Testimonials";
import Pricing from "../components/Pricing";
import FAQ from "../components/FAQ";
import FinalCTA from "../components/FinalCTA";
import Footer from "../components/Footer";
import CookieBanner from "../components/CookieBanner";
import { createCheckoutSession } from "../lib/api";

const BANNER_STORAGE_KEY = "promo_banner_inicio10_dismissed";

export default function LandingPage() {
  const [loading, setLoading] = useState(false);
  const [bannerVisible, setBannerVisible] = useState(false);

  useEffect(() => {
    const dismissed = localStorage.getItem(BANNER_STORAGE_KEY);
    if (!dismissed) setBannerVisible(true);
  }, []);

  const dismissBanner = () => {
    localStorage.setItem(BANNER_STORAGE_KEY, "1");
    setBannerVisible(false);
  };

  const handleBuy = async () => {
    if (loading) return;
    setLoading(true);
    // Meta Pixel: track user intent before redirecting to Stripe
    if (typeof window !== "undefined" && window.fbq) {
      window.fbq("track", "InitiateCheckout", {
        value: 29.90,
        currency: "EUR",
        content_name: "Workbook — Quando já não dá para continuar igual",
        content_ids: ["workbook-anabela-reis"],
        content_type: "product",
      });
    }
    try {
      const data = await createCheckoutSession({
        origin_url: window.location.origin,
      });
      if (data.url) {
        window.location.href = data.url;
      } else {
        toast.error("Não foi possível iniciar o pagamento. Tenta novamente.");
        setLoading(false);
      }
    } catch (err) {
      // Toast already surfaces the error to the user; log only in dev.
      if (process.env.NODE_ENV !== "production") {
        // eslint-disable-next-line no-console
        console.error(err);
      }
      toast.error("Erro ao processar checkout. Verifica a tua ligação.");
      setLoading(false);
    }
  };

  return (
    <main data-testid="landing-page" className="relative">
      <PromoBanner visible={bannerVisible} onDismiss={dismissBanner} />
      <Nav onBuy={handleBuy} bannerOffset={bannerVisible} />
      <Hero onBuy={handleBuy} />
      <About />
      <ForYou />
      <Chapters />
      <Interlude />
      <Preview />
      <SamplePages />
      <Author />
      <Manifesto />
      <Testimonials />
      <Pricing onBuy={handleBuy} loading={loading} />
      <FAQ />
      <FinalCTA onBuy={handleBuy} />
      <Footer />
      <CookieBanner />
    </main>
  );
}
